import { useState } from 'react';
import { Info, X, ChevronDown } from 'lucide-react';
import { RISK_BANDS } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { AnimatePresence, motion } from 'framer-motion';

export const RiskScoreLegend = ({ compact = false }) => {
  const [open, setOpen] = useState(false);

  if (compact) {
    return (
      <div className="relative inline-block">
        <button
          onClick={() => setOpen(!open)}
          className="flex items-center gap-1 text-xs text-[#4E6974] hover:text-[#0097A7] transition-colors"
          data-testid="risk-legend-toggle"
        >
          <Info className="h-3 w-3" /> Risk scale
          <ChevronDown className={`h-3 w-3 transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ opacity: 0, y: -4 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -4 }}
              className="absolute z-50 top-full left-0 mt-1 w-[360px] bg-white rounded-lg shadow-[0_8px_32px_rgba(0,0,0,0.12)] border border-[#E0E0E0] p-3"
              data-testid="risk-legend-popup"
            >
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs font-semibold text-[#0D3B4F]">Risk score interpretation</span>
                <button onClick={() => setOpen(false)} className="text-[#4E6974] hover:text-[#0D3B4F]"><X className="h-3 w-3" /></button>
              </div>
              <div className="space-y-1.5">
                {RISK_BANDS.map(b => (
                  <div key={b.level} className="flex items-start gap-2">
                    <Badge className={`${b.bg} ${b.text} text-[10px] min-w-[70px] justify-center flex-shrink-0`}>{b.min}-{b.max}</Badge>
                    <div>
                      <span className="text-[11px] font-medium text-[#0D3B4F]">{b.level}</span>
                      <p className="text-[10px] text-[#4E6974] leading-tight">{b.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid="risk-legend-bar">
      {RISK_BANDS.map(b => (
        <div key={b.level} className="flex items-center gap-1 group relative">
          <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: b.color }} />
          <span className="text-[10px] text-[#4E6974]">{b.min}-{b.max} {b.level}</span>
          <div className="hidden group-hover:block absolute z-50 bottom-full left-0 mb-1 w-[240px] bg-[#0A2533] text-white text-[10px] p-2 rounded shadow-lg">
            {b.desc}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RiskScoreLegend;
